import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import "./style.scss";

/**
 * DialysisDragDropQuestion-MainHeader
 *  - header section for the DialysisDragDropQuestion Component.
 */
export function MainHeader(props) {
  console.log();

  return (
    <>
      <h6 className="dialysisdragdropquestion_title">Prediction Question</h6>
      {props.heading ? (
        <h5 className="dialysisdragdropquestion_header">
          {" "}
          <RichText {...props.heading} />{" "}
        </h5>
      ) : null}
      {props.text ? (
        <p className="dialysisdragdropquestion_text">
          <RichText {...props.text} />
        </p>
      ) : null}
    </>
  );
}

MainHeader.propTypes = {
  /**
   * Main heading for the quetion
   */
  heading: PropTypes.string,
  /**
   * Detailed description for the question
   */
  text: PropTypes.string,
};
